<template>
  <div v-if="_couponList && _couponList.length > 0" class="coupon-container">
    <div
      v-for="(coupon, index) in _couponList"
      :key="index"
      class="coupon-detail"
    >
      <!---左侧 优惠劵-->
      <div class="coupon-price" :class="coupon.status !== 1 && 'none'">
        <div class="price-wrap">
          <span class="unit">¥</span>
          <span class="price">{{ coupon.couponValue / 100 }}</span>
        </div>
        <div v-show="coupon.status === 1" class="limit">
          仅剩{{ coupon.leftNum }}张
        </div>
      </div>
      <!---中间 使用描述-->
      <div class="coupon-right">
        <p class="title">
          {{ coupon.displayName }}
        </p>
        <p class="text threshold">
          {{
            type === 'shipping' || type === 'service'
              ? '无门槛'
              : `满${coupon.threshold / 100}可用`
          }}
        </p>
        <p v-if="type !== 'shipping'" class="text">
          ({{ coupon.description }})
        </p>
      </div>
      <div class="coupon-status">
        <div v-if="coupon.status === 1" class="exchange">
          <div class="score">
            <img src="@/images/integral/jifen@3x.png" />
            <span>{{ coupon.score }}</span>
          </div>
          <div class="btn" @click="handleSubmit(coupon)">立即兑换</div>
        </div>
        <div v-else class="status loot-all" />
      </div>
    </div>
    <!--底部更多-->
    <div
      v-if="couponList.length > 3"
      class="footer"
      @click="isFooterShowMore = !isFooterShowMore"
    >
      <span class="txt">{{ isFooterShowMore ? '查看更多' : '收起' }}</span>
      <img
        src="@/images/arrow/arrow_bottom@3x.png"
        :class="['arrow', !isFooterShowMore ? 'arrow-rotate' : '']"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CouponList',
  props: {
    couponList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      isFooterShowMore: true
    }
  },
  computed: {
    _couponList() {
      if (this.couponList.length <= 3) {
        return this.couponList
      }
      return this.isFooterShowMore
        ? this.couponList.slice(0, 3)
        : this.couponList
    }
  },
  methods: {
    handleSubmit(coupon) {
      let couponType
      if (this.type === 'shipping') {
        couponType = '1'
      } else if (this.type === 'service') {
        couponType = '6'
      } else {
        couponType = '0'
      }
      this.$track(this.$trackMap.memberIntegral.EXCHANGE_LIST, {
        coupon_id: coupon.actionId,
        coupon_type: couponType
      })
      this.$emit('receiveCoupon', coupon)
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-container {
  position: relative;
  padding-bottom: 0.28rem;
  .content-title {
    font-size: 0.28rem;
    color: #999;
    padding: 0 0 0.2rem;
  }
  .coupon-detail {
    position: relative;
    display: flex;
    & + .coupon-detail {
      margin-top: 0.26rem;
    }
    .coupon-price {
      position: relative;
      @include flex-row-center;
      width: 1.76rem;
      height: 1.5rem;
      background-size: 100% 100%;
      background-image: url('~@/images/integral/coupon_left@2x.png');
      &.none {
        background-image: url('~@/images/integral/coupon_none_left@2x.png');
      }
      .price-wrap {
        display: flex;
        align-items: baseline;
        font-weight: 900;
        color: #fff;
        .unit {
          font-size: 0.36rem;
        }
        .price {
          font-size: 0.8rem;
        }
      }
      .limit {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0.08rem 0.16rem;
        font-size: 0.2rem;
        line-height: 0.2rem;
        border-radius: 4px 0 4px 0;
        background-image: linear-gradient(to left, #c59569, #f1c89c);
      }
    }
    .coupon-right {
      position: relative;
      padding: 0.24rem 0.24rem 0;
      flex: 1;
      background-size: 100% 100%;
      background-image: url('~@/images/integral/coupon_right@2x.png');
      .title {
        font-size: 0.3rem;
        line-height: 0.3rem;
        font-weight: 600;
        color: #333;
      }
      .text {
        color: #999;
        width: 2.8rem;
        font-size: 0.24rem;
        line-height: 0.24rem;
        @include text-overflow-ellipsis-single;
        &.threshold {
          margin: 0.14rem 0 0.1rem;
        }
      }
    }
    .coupon-status {
      position: absolute;
      right: 0.44rem;
      @include flex-row-center;
      width: 1.5rem;
      height: 100%;
      .exchange {
        @include flex-column-center;
        width: 1.5rem;
        .score {
          margin-left: -0.08rem;
          @include flex-row-center;
          img {
            margin-top: -0.02rem;
            width: 0.28rem;
            height: 0.28rem;
          }
          span {
            margin-left: 0.02rem;
            font-weight: bold;
            font-size: 0.28rem;
            color: #333;
          }
        }
        .btn {
          margin-top: 0.08rem;
          width: 1.44rem;
          height: 0.48rem;
          line-height: 0.48rem;
          text-align: center;
          color: #fff;
          font-size: 0.24rem;
          border-radius: 0.3rem;
          background-image: linear-gradient(to right, #ff7d5e, #ff3410);
        }
      }
      .status {
        width: 1.3rem;
        height: 1.3rem;
        background-size: 100% 100%;
        &.loot-all {
          background-image: url('~@/images/integral/loot_all@2x.png');
        }
      }
    }
  }

  .footer {
    @include flex-row-center;
    margin: 0.4rem 0 0;
    .txt {
      font-size: 0.24rem;
      color: #999999;
      text-align: center;
    }
    .arrow {
      width: 0.2rem;
      height: 0.15rem;
      margin-left: 0.1rem;
      vertical-align: middle;
    }
    .arrow-rotate {
      transform: rotate(180deg);
    }
  }
}
</style>
